<cmps-dialog
    class="cmps-event-centre-c-pop-dialog--dialog cmps-cdk-px-1"
    [class.cmps-event-centre-c-pop-dialog--multiple]="_multiple"
    [style.background-image]="'url(' + _mapItem?.tpl?.backgroundImage + ')'"
>
    <cmps-dialog-header
        [closeTooltip]="_i18n._763_CLOSE | translate"
    ></cmps-dialog-header>
    <cmps-dialog-body>
        <div
            class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-align-items-center"
        >
            <div class="cmps-event-centre-c-pop-dialog--title-image">
                <img
                    class="w-100"
                    [src]="_mapItem?.tpl?.titleImage"
                    alt=""
                />
            </div>
            <div class="cmps-cdk-mt-0dot5">
                <div
                    class="cmps-event-centre-c-pop-dialog--title cmps-cdk-color-blue-100 cmps-cdk-font-bold"
                >
                    {{ _mapItem?.tpl?.title }}
                </div>
            </div>
            <div class="cmps-cdk-mt-1">
                <div class="cmps-event-centre-c-pop-dialog--message">
                    {{ _mapItem?.tpl?.subTitle }}
                </div>
            </div>
            <div
                class="cmps-cdk-mt-1"
                #containerRef
            >
                <ng-container #ref></ng-container>
            </div>
            <div
                class="w-100 cmps-event-centre-c-pop-dialog--footer cmps-cdk-mt-1 cmps-cdk-align-items-center"
            >
                <img
                    src="assets/intelligent-coach-assist-logo-horizontal.svg"
                    alt=""
                />
                <div
                    class="cmps-event-centre-c-pop-dialog--pos cmps-cdk-color-grey-400"
                    *ngIf="_multiple"
                >
                    <span>{{ _pos }} / {{ _data?.length }}</span>
                </div>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>

<div class="cmps-event-centre-c-pop-dialog--btn-left cmps-cdk-pos-absolute">
    <button
        cmpsIconButton
        (click)="_onLeftClick()"
        *ngIf="_multiple"
    >
        <cmps-icon
            class="cmps-cdk-bg-color-black"
            svgIcon="chevron-left"
        ></cmps-icon>
    </button>
</div>

<div class="cmps-event-centre-c-pop-dialog--btn-right cmps-cdk-pos-absolute">
    <button
        cmpsIconButton
        (click)="_onRightClick()"
        *ngIf="_multiple"
    >
        <cmps-icon
            class="cmps-cdk-bg-color-black"
            svgIcon="chevron-right"
        ></cmps-icon>
    </button>
</div>

<div
    class="cmps-event-centre-c-pop-dialog--progress cmps-cdk-pos-absolute cmps-cdk-bg-color-grey-300"
    *ngIf="_multiple"
>
    <div
        [style.width.%]="_progress"
        class="cmps-event-centre-c-pop-dialog--progress-bar cmps-cdk-bg-color-blue-100"
    ></div>
</div>
